/**
 * Сюда необходимо добавлять ресурсы, которые критичны для первичного рендеринга.
 * Эти ресурсы будут подгружаться синхронно.
 */

import '../shared/utils/preventScaling.css';
import '../shared/components/ControlButton/styles.css';
import '../shared/components/Navigation/Navigation.css';
import '../shared/components/Navigation/buttons/styles.css';
